import { Rank } from '../../sim/defs';
import { defineEnemy, Motion } from '../schema';

/** E01 — MITE. Popcorn pur.
 *
 *  Meurt en un impact et ne tire jamais. Son rôle n'est pas d'être dangereux
 *  mais de REMPLIR LES CREUX DU RYTHME sans coûter d'attention : il alimente la
 *  chaîne de score et donne au joueur quelque chose à faire entre deux menaces
 *  réelles. Un shmup sans popcorn se lit comme une suite d'épreuves ; avec, il
 *  respire.
 *
 *  Arrive par groupes échelonnés de 0,08 s — la lecture est celle d'une nuée,
 *  pas d'un mur. */
export default defineEnemy({
  id: 'mite',
  rank: Rank.Popcorn,
  hp: 30,
  visualRadius: 22,
  score: 60,
  telegraph: 0.7,
  drops: 1,
  motion: { kind: Motion.Linear, speed: 420 },
});

